export default __webpack_public_path__ + "static/media/tryonexpress-logo.3b5d8ccc.png";